var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoNotificationsData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4812_2145)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.76901 0.991493L79.0085 74.2309V74.2253C80.3268 75.5436 80.3268 77.6844 79.0085 79.0028C78.3493 79.6619 77.4817 79.9943 76.6197 79.9943C75.7577 79.9943 74.8901 79.6619 74.231 79.0028L64.5183 69.2901H50.1408C50.1408 74.8901 45.6 79.4309 40 79.4309C34.4 79.4309 29.8592 74.8901 29.8592 69.2901H6.19718C8.42253 64.845 9.57746 59.938 9.57746 54.969V30.9802C9.57746 26.1408 10.7155 21.5661 12.7268 17.5042L0.991546 5.76896C-0.332397 4.45065 -0.332397 2.3098 0.991546 0.991493C2.30986 -0.332451 4.4507 -0.332451 5.76901 0.991493ZM36.6197 69.2957C36.6197 71.1605 38.1352 72.676 40 72.676C41.8648 72.676 43.3803 71.1605 43.3803 69.2957H36.6197ZM16.338 54.9746C16.338 57.5098 16.0845 60.045 15.5887 62.5352H57.7577L17.8648 22.6422C16.8789 25.2394 16.338 28.0506 16.338 30.9859V54.9746ZM41.5887 7.37456C41.0592 7.34076 40.5239 7.32385 40 7.32385C34.8225 7.32385 30.0338 9.00273 26.1352 11.8309L21.3014 6.99709C26.462 2.96892 32.9465 0.563291 40 0.563291C40.6704 0.563291 41.3465 0.585826 42.0282 0.630897C58.1972 1.67878 70.4225 15.8253 70.4225 32.0281V54.9746C70.4225 55.3633 70.439 55.7465 70.4556 56.1351L70.4563 56.152L63.662 49.3577V32.0281C63.662 19.0027 53.9662 8.17456 41.5887 7.37456Z",
    fill: "#CFCFCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4812_2145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotificationsData);
export default __webpack_public_path__ + "static/media/no-notifications-data.3f61f7e3ad6656acbc5e4a5232746b06.svg";
export { ForwardRef as ReactComponent };